import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useTranslation } from 'react-i18next';
import config from "../../../lib/config";
import exportTitleTable from "../../../lib/exportTitleTable";
import { IPtStatsSummary } from "../../../models/statistics.model";
import DownloadButton from "../../DownloadButton";
import Pagination from "../../Pagination";

interface IProps {
  rawData: IPtStatsSummary[]|undefined;
  excelCampusCodes: string[];
  excelPeriod: string|undefined;
}

const PtStatsSummary: FC<IProps> = ({
  rawData,
  excelCampusCodes,
  excelPeriod
}) => {
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  
  const [data, setData] = useState<IPtStatsSummary[]>([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (rawData) {
      const _data: IPtStatsSummary[] = _.cloneDeep(rawData);

      if (rawData?.length) {
        _data.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
        });
      }

      setData(_data);
    }
  } ,[rawData]);

  const onExportTable = () => {
    const currentDate = moment(new Date());

    let excelTitle = `${t('statistics.placementTest.title1')}(${t('statistics.attendance.Tab1')})`;
    let arrSubTitle = [];
    let campusNames = '';

    if(excelCampusCodes) {
      if(excelCampusCodes.length == 0) {
        campusNames = t('common.text.all');
      } else {
        excelCampusCodes.forEach((item) => {
          if(campusNames != '') {
            campusNames += ', '  
          }
          campusNames += campusData.find(campus => item == campus.campusCode)?.campusKorName;
        });
      }
    }

    arrSubTitle.push(t('common.excel.campus') + " : " + campusNames);
    if(excelPeriod !== '') {
      arrSubTitle.push(t('common.excel.period') + " : " + excelPeriod);
    }
    
    exportTitleTable(columns, data, `${t('statistics.placementTest.title1')}(${t('statistics.attendance.Tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.attendance.Tab1')}`, [12, 15, 12, 10, 10, 10, 12], excelTitle, arrSubTitle);
  }

  const columns: TableColumnsType<IPtStatsSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.placeholder1'),
      dataIndex: 'examTypeName',
      key: 'examTypeName',
      align: 'center',
      className: 'ptStats-hl',
      render: (value, record) => {
        if(record.campusCode === "0") {
          return '-';
        } else {
          return value;
        }
      }
    },
    {
      title: t('statistics.dttt.column2'),
      dataIndex: 'overall',
      key: 'overall',
      align: 'center',
      render: value => value,
    },
    {
      title: t('statistics.placementTest.column1'),
      dataIndex: 'averageTimeRequired',
      key: 'averageTimeRequired',
      align: 'center',
      render: value => (value === '0' || value === null) ? '-' : Math.floor(value),
    },
    {
      title: t('statistics.placementTest.column2'),
      dataIndex: 'totalRequireCount',
      key: 'totalRequireCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column3'),
      dataIndex: 'participantCount',
      key: 'participantCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column4'),
      dataIndex: 'nonparticipantCount',
      key: 'nonparticipantCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column5'),
      dataIndex: 'participantRate',
      key: 'participantRate',
      align: 'center',
      render: value => value,
    },
  ];

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: config.pageSize,
          }}
          rowClassName={(record: IPtStatsSummary) => (record.campusCode === '0' || record.campusCode === '1') ? 'tfoot' : ''}
          rowKey={'rowIdx'}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={data.length}
            page={page}
            setPage={setPage}
          />
        </div>
        <div className="col-3" />
      </div>
    </>
  );
}

export default PtStatsSummary;
